<script setup>
import {ref} from "vue";
import {animate} from "@straylightagency/animate";
import {easeInQuad} from "@straylightagency/animate/easing"
import {getElementSizing, closestElement} from "@straylightagency/utils/dom";
import {__} from "../lib/localization/index.js";

const props = defineProps({
    next: String,
});

const el = ref();

async function goTo() {
    document.body.classList.add('overflow-hidden');

    const next_section = closestElement( el.value, 'section' );

    if ( next_section ) {
        const sizing = getElementSizing( next_section );

        await animate( {
            from: window.scrollY,
            to: window.scrollY + (sizing.top - sizing.marginTop - sizing.paddingTop),
            duration: 1000,
            easing: easeInQuad,
            update: value => window.scrollTo( 0, value ),
        } );
    }

    document.body.classList.remove('overflow-hidden');
}
</script>

<template>
    <button ref="el" @click.prevent="goTo" class="scroll-down" :title="__('labels.keep-scrolling')">
        <slot></slot>
    </button>
</template>